import IdleTimerContainer from './IdleTimerContainer';
export default IdleTimerContainer;
